import { render, staticRenderFns } from "./incomeDistribution.vue?vue&type=template&id=36605874&scoped=true&"
import script from "./incomeDistribution.vue?vue&type=script&lang=js&"
export * from "./incomeDistribution.vue?vue&type=script&lang=js&"
import style0 from "./incomeDistribution.vue?vue&type=style&index=0&id=36605874&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36605874",
  null
  
)

export default component.exports